import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "share" }
const _hoisted_2 = { class: "share-form" }
const _hoisted_3 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ShareDropdown = _resolveComponent("ShareDropdown")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_Loader = _resolveComponent("Loader")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    "modal-to": "#chat",
    min_width: $options.size,
    max_width: $options.size,
    onAfterLeave: _cache[2] || (_cache[2] = $event => ($data.loading = false))
  }, {
    header: _withCtx(() => _cache[3] || (_cache[3] = [
      _createTextVNode(" Share this conversation ")
    ])),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "description" }, [
          _createTextVNode(" This conversation may include personal information. "),
          _createElementVNode("br"),
          _createTextVNode(" Take a moment to check the content before sharing the link. ")
        ], -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "Access", -1 /* HOISTED */)),
          _createVNode(_component_ShareDropdown, {
            modelValue: $data.shared,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.shared) = $event)),
            class: "dropdown"
          }, null, 8 /* PROPS */, ["modelValue"])
        ]),
        _createVNode(_component_Divider, { m: "3.2rem -2.5rem 0" }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Button, {
            disabled: !$data.shared,
            onClick: _cache[1] || (_cache[1] = () => $options.copyLink())
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                stroke: "var(--gray-700)",
                icon: "copy-01"
              }),
              _cache[5] || (_cache[5] = _createTextVNode(" Copy Link "))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled"]),
          _createVNode(_component_Button, {
            class: "done-btn",
            primary: "",
            onClick: $options.close
          }, {
            default: _withCtx(() => [
              ($data.loading)
                ? (_openBlock(), _createBlock(_component_Loader, {
                    key: 0,
                    inline: "",
                    mini: "",
                    color: "var(--base-white)"
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Done")
                  ], 64 /* STABLE_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["min_width", "max_width"]))
}